/*
 * Óptica Córdoba — Dropdown de navegación por hover (solo escritorio).
 * Reutiliza la estructura nativa de Dawn (<header-menu><details>): el panel
 * abre al pasar el cursor en lugar de al hacer click. El estilo (vidrio
 * esmerilado full-width) vive en cordoba.css. No modifica el menú móvil:
 * en <990px la barra inline está oculta y los manejadores no hacen nada.
 */
(function () {
  var mql = window.matchMedia('(min-width: 990px)');

  function init() {
    var nav = document.querySelector('.header__inline-menu');
    if (!nav) return;

    var menus = nav.querySelectorAll('header-menu');
    if (!menus.length) return;

    var wrapper = document.querySelector('.header-wrapper');

    function closeAll(except) {
      menus.forEach(function (menu) {
        if (menu === except) return;
        var details = menu.querySelector('details');
        if (details) details.removeAttribute('open');
      });
    }

    menus.forEach(function (menu) {
      var details = menu.querySelector('details');
      if (!details) return;

      var closeTimer;

      menu.addEventListener('mouseenter', function () {
        window.clearTimeout(closeTimer);
        if (!mql.matches) return;
        closeAll(menu);
        // Alinea la lista justo debajo de este ítem del menú.
        var summary = details.querySelector('summary');
        var panel = details.querySelector('.header__submenu');
        if (summary && panel) {
          var label = summary.querySelector('span') || summary;
          var left = Math.round(label.getBoundingClientRect().left);
          panel.style.setProperty('--cordoba-submenu-left', left + 'px');
        }
        if (!details.hasAttribute('open')) details.setAttribute('open', '');
      });

      menu.addEventListener('mouseleave', function () {
        window.clearTimeout(closeTimer);
        if (!mql.matches) return;
        closeTimer = window.setTimeout(function () {
          details.removeAttribute('open');
        }, 160);
      });
    });

    // Cierra al abandonar el header por completo.
    if (wrapper) {
      wrapper.addEventListener('mouseleave', function () {
        if (!mql.matches) return;
        closeAll(null);
      });
    }
  }

  if (document.readyState !== 'loading') {
    init();
  } else {
    document.addEventListener('DOMContentLoaded', init);
  }
})();
